<div class="form-title-container">
    <!-- Back to registration page -->
    <div class="nav-buttons">
        <button class="nav-button edit-button" routerLink="/form">Edit Info</button>
    </div>

    <div class="total-info">
        Total Registers:
        <span *ngIf="registers.length != undefined">{{registers.length}}</span>
        <span *ngIf="registers.length == undefined">0</span>
    </div>
</div>

<form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" class="checkout-form">

    <!-- Registration info review -->
    <div>
        <table class="table-container">
            <tr class="table-row">
                <th class="col-md-6">Name and Shirt Size</th>
                <th class="col-md-2">Age</th>
                <th class="col-md-2">Gender</th>
                <th class="col-md-2">Cost</th>
                <th class="col-md-2"></th>
            </tr>

            <tr *ngFor="let attendee of registers" class="table-row">
                <td class="col-md-6">
                    {{attendee.first_name}} {{attendee.last_name}}
                    <br>Shirt Size: <b>{{attendee.t_shirt}}</b>
                </td>
                <td class="col-md-2">{{attendee.age}}</td>
                <td class="col-md-2">{{attendee.gender}}</td>
                <td class="col-md-2">{{attendee.cost | currency }}</td>
        </table>


        <!-- total fee -->
        <div class="cost-info">Sub-Total: ${{total_cost}}</div>
    </div>

    <!-- spacing -->
    <div style="height: 30px;"></div>

    <ngx-spinner bdOpacity=0.9 bdColor="#333" size="medium" color="#fff" type="ball-zig-zag-deflect"
        [fullScreen]="true">
        <p style="color: white"> Processing Payment... </p>
    </ngx-spinner>

    <!-- spacing -->
    <div style="height: 30px;"></div>

    <div class="nav-buttons">

        <button [disabled]='button_disabled' class="nav-button next-button" type="submit">
            Pay {{total_cost | currency}}
        </button>
    </div>




    <!-- spacing -->
    <div style="height: 200px;"></div>